export default "__VITE_ASSET__uzrzfnkS__"